module.exports = __webpack_public_path__ + "img/AdobeStock_288918723.86a39e41.jpeg";